import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import NotebookEditor from '../NotebookEditor';
import HttpServices from '../../utils/Http.services';
import { changeSelectedTextEffects, textEffectsList } from '../../variables/notebook';
import CustomLoader from '../../components/CustomLoader';
import { nanoid } from 'nanoid';

class DriveNoteEditor extends Component {

    state = {
        file: {},
        textEffectsList: [...textEffectsList],
        currentPage: 0

    }

    componentDidMount() {
        this.getNote()

    }

    componentDidUpdate(prevProps, prevState) {

        if (JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path)) {
            this.getNote()
        }

    }

    getNote = () => {

        let pathname = this.props.windowData.path
        let id = pathname[this.props.baseUrl.length]

        // console.log(id)
        if (id) {
            this.setState({ isLoading: true })
            HttpServices.request('getNote', { link: id }, (fetchResult, fetchError) => {

                this.setState({ isLoading: false })

                if (fetchError) {
                    return
                }
                this.setState({ noteTitle: fetchResult.file?.name, file: fetchResult.file, pagesData: fetchResult.info }, () => {
                    this.notebookEditor.setNoteData()
                    this.props.setHeader('dummy', 1)

                })
            })
        }
    }

    // saveNote = (content) => {
    //     if (this.state.file?.temp) {
    //         this.saveDoc(content)
    //     } else {
    //         this.saveDoc(content)
    //     }
    // }


    saveDoc = (content) => {
        // console.log("saveDoc")

        if (!this.state.noteTitle || this.state.noteTitle.trim() == '') {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}Name is not valid', description: '{{lang}}You need to add a name for the file.' })
            return
        }

        let data = { name: this.state.noteTitle };
        // data.applet = this.props.applet?._id ?? this.props.applet ?? this.state.currentApplet?._id ?? this.state.currentApplet
        // data.frame = this.props.page?._id ?? this.state.file?._id
        // data.folder = this.state.paths[this.state.paths.length - 1]._id ?? null
        // data.note = content
        data._id = this.state.file?._id;
        data.link = this.state.file?.link;

        // console.log(this.state.file, this.state.currentPage)

        let pagesData = this.state.pagesData
        pagesData[this.state.currentPage].content = content

        let pages = this.state.file.pages

        // console.log("pageData",pagesData)

        pages.forEach((page, i) => {
            pagesData.forEach(pageData => {
                if (page.id == pageData.id) {
                    // console.log("Found",page.id)
                    pages[i].content = pageData.content
                }
            });
        });

        // return
        // if (id) {
        //     data._id = id;
        // }
        if (this.state.file?._id) {
            data._id = this.state.file._id
        }

        if (this.state.file?.link) {
            data.link = this.state.file.link
        }
        data.pages = pages

        // console.log(data)
        // this.setState({ bodyValue: '' })
        HttpServices.request("saveDoc", data, (fetchResolve, fetchError) => {

            // console.log(fetchResolve, fetchError)


            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.savedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })

            // this.init();
            // this.stageManager.changeStage("main");
            // this.setState({ titleValue: "", file: null });
            // this.props.backToFileManager()
        });
    };

    // updateNote = (content) => {

    //     console.log("updateNote")

    //     // let content = document.getElementById(this.state.editorId).getInputValue();
    //     let pageInfo = [{ body: content, pagename: '1st Page' }]
    //     let data = { title: this.state.noteTitle, content: pageInfo };
    //     data._id = this.state.file?._id;
    //     data.link = this.state.file?.link;

    //     // this.setState({ bodyValue: '' })
    //     console.log(data)
    //     // return
    //     HttpServices.request("updateNote", data, (fetchResolve, fetchError) => {
    //         if (fetchError) {
    //         }
    //         // this.init();
    //         // this.stageManager.changeStage("main");
    //         this.setState({ titleValue: "" });
    //         // this.props.backToFileManager()
    //     });
    // };

    changeNotePage = (page) => {
        let path;
        if (page) {
            if (Array.isArray(page)) {
                path = page;
            } else {
                path = [page?.key ?? page];
            }
        }
        this.changeWindowLink(path);
    };


    updateTextEffectsStyleStatus = (activeStyles = []) => {
        const textEffectsList = [...this.state.textEffectsList];
        textEffectsList.forEach(textEffect => {
            const activeStyle = activeStyles.find(activeStyle => activeStyle === textEffect.styleName);
            if (activeStyle) {
                textEffect.isStyleActive = true
            } else {
                textEffect.isStyleActive = false

            }
        })
        this.setState({ textEffectsList })
    }


    setName = (value, cb) => {
        this.setState({ noteTitle: value }, () => {
            if (cb)
                cb()
        });
    }

    addNewPage = () => {
        // console.log("addNewPage")
        let file = this.state.file
        let pagesData = this.state.pagesData
        let currentPage = this.state.currentPage
        file.pages[currentPage].content = this.notebookEditor.getContent()
        // currentPage = file.pages?.length + 1
        let newPage = { content: '', id: nanoid() }
        file.pages.push(newPage)
        pagesData.push(newPage)
        currentPage = file.pages.length - 1
        // console.log(file)
        this.setState({ pagesData, file, currentPage }, () => {
            this.notebookEditor.setNoteData()
            this.props.setHeader('dummy', 1)
            // console.log('thisfffff,f', this.state.pagesData, this.state.currentPage)
        })
    }

    switchPage = (page, extra) => {
        // console.log("switchPage", extra)
        let file = this.state.file
        let currentPage = this.state.currentPage


        if (currentPage != extra.index) {

            let pagesData = this.state.pagesData

            file.pages[currentPage].content = this.notebookEditor.getContent()
            pagesData[currentPage].content = file.pages[currentPage].content

            // console.log(file)

            this.setState({ pagesData, file, currentPage: extra.index }, () => {
                this.notebookEditor.setNoteData()
                this.props.setHeader('dummy', 1)

            })
        }
    }



    render() {
        return (
            <div ref={el => this.container = el} className={"driveNoteEditor w-100 h-100 "} >

                {this.state.isLoading && (
                    <div className="mt-2 d-flex justify-content-center pt-4">
                        <CustomLoader isLoading={true} />
                    </div>
                )}
                {!this.state.isLoading && (
                    <NotebookEditor
                        ref={el => this.notebookEditor = el}
                        currentPage={this.state.currentPage}
                        applet={this.props.applet ?? this.props.currentApplet ?? this.state.currentApplet}
                        changeSelectedTextEffects={(effectType, id) => changeSelectedTextEffects(effectType, id, this.updateTextEffectsStyleStatus)}
                        editorId={this.state.editorId}
                        changeStagePage={this.changeStagePage}
                        updateTextEffectsStyleStatus={this.updateTextEffectsStyleStatus}
                        textEffectsList={[...this.state.textEffectsList]}
                        language={this.props.language}
                        width={this.props.width}
                        setName={this.setName}
                        backToFileManager={this.props.backToFileManager}
                        noteTitle={this.state.noteTitle}
                        data={this.state.pagesData}
                        setData={this.setData}
                        page={this.props.page}
                        file={this.state.file}

                        note={this.state.note}
                        changeNotePage={this.changeNotePage}
                        titleValue={this.titleValue}
                        title={this.state.titleValue}
                        saveDoc={this.saveDoc}
                        // updateNote={this.updateNote}
                        // saveNote={this.saveNote}

                        isLoading={this.props.isLoading}
                        addNewPage={this.addNewPage}
                        switchPage={this.switchPage}

                        setHeader={this.props.setHeader}
                        colors={this.props.colors}
                        isDesktop={this.props.isDesktop}
                        changeStage={this.changeStagePage}
                        appletType={'drive'}

                    />

                )}
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, queque: state.queque })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(DriveNoteEditor);